var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocked = function SvgLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.222 19H7.778C6.8 19 6 18.147 6 17.105v-5.21C6 10.853 6.8 10 7.778 10h8.444C17.2 10 18 10.853 18 11.895v5.21C18 18.147 17.2 19 16.222 19Zm-8.444-8.053c-.49 0-.89.427-.89.948v5.21c0 .521.4.948.89.948h8.444c.49 0 .89-.427.89-.948v-5.21c0-.521-.4-.948-.89-.948H7.778Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.941 9.996H8V7.447C8 5.807 9.264 4 12 4c2.736 0 4 1.77 4 3.447v2.875h-.941V7.447c0-1.23-1.25-2.702-3.059-2.702-1.81 0-3.059 1.435-3.059 2.702v2.549Z"
  }))));
};
export default SvgLocked;